import React from 'react';
import {useState, useEffect} from "react";
import {Box, SimpleGrid} from '@chakra-ui/react';
import Item from './item';

import {motion} from 'framer-motion';

const Motioned = motion(Box);

export function useWindowSize() {
    const [windowSize, setWindowSize] = useState({
        width: undefined,
        height: undefined,
    });
    useEffect(() => {
        function handleResize() {
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        }

        window.addEventListener("resize", handleResize);
        handleResize();
        return () => window.removeEventListener("resize", handleResize);
    }, []);
    return windowSize;
}

const SimpleRowGrid = (props) => {
    const {data} = props;
    const size = useWindowSize();
    const isTablet = size.width > 768 ? false : true
    return (
        <>
            <SimpleGrid
                width="100%"
                maxW="100%"
                minW="100%"
                mx={0}
                columns={isTablet ? 1 : [1, 1, 3, 4, 4]}
                spacingX="40px"
                spacingY={isTablet ? '0' : '40px'}
                px={'20px'}
                className={'simplerowa'}
            >
                {data?.map((item, index) => (
                    <Motioned
                        initial={{y: index + 1 * 50, opacity: 0}}
                        animate={{y: 0, opacity: 1}}
                        transition={{
                            delay: 0.3,
                            default: {duration: 0.25 * index + 1},
                        }}
                        mb={'40px'}
                        maxH={'283'}
                        height={item.height}
                        key={index}
                        area={item.area}
                    >
                        <Item {...item} minH={true}/>
                    </Motioned>
                ))}
            </SimpleGrid>
        </>
    );
};

export default SimpleRowGrid;
